import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import { Box, Typography, Chip, LinearProgress } from '@mui/material';
import {
  ACTIVE_RENDER_STATUSES,
  PIPELINE_CHIP_SX,
  PIPELINE_RENDER_LABELS,
  PIPELINE_RENDER_COLORS,
  SCRIPT_IN_PROGRESS_STATUSES,
  VOICEOVER_STATUS_CHIP,
} from './constants';
import { getVoiceOverStatus, getRenderProgress } from './pipelineUtils';

export default function PipelineStatusCell({ item, scriptStatus, scriptChip, progress, now }) {
  const voStatus = getVoiceOverStatus(item);
  const voChip = VOICEOVER_STATUS_CHIP[voStatus] || VOICEOVER_STATUS_CHIP.idle;
  const renderStatus = item.renderStatus?.status || 'idle';
  const renderProgressInfo = getRenderProgress(item.renderStatus, item.voiceOverDuration, now);
  const scriptInProgress = SCRIPT_IN_PROGRESS_STATUSES.includes(scriptStatus);
  const renderInProgress = ACTIVE_RENDER_STATUSES.includes(renderStatus);
  const videoLabel = renderInProgress && renderProgressInfo?.text
    ? renderProgressInfo.text
    : (PIPELINE_RENDER_LABELS[renderStatus] ?? 'None');
  const videoColor = renderInProgress ? 'warning' : (PIPELINE_RENDER_COLORS[renderStatus] ?? 'default');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'nowrap', minWidth: 0 }}>
        <Typography variant='caption' color='text.secondary' sx={{ flexShrink: 0 }}>Script</Typography>
        {scriptStatus === 'completed' ? (
          <CheckIcon color='success' fontSize='small' titleAccess='Script completed' sx={{ flexShrink: 0 }} />
        ) : scriptInProgress ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
            <LinearProgress
              variant='determinate'
              value={progress}
              sx={{ width: 56, height: 5, borderRadius: 1 }}
            />
            <Typography variant='caption' sx={{ flexShrink: 0, minWidth: 28 }}>{progress}%</Typography>
          </Box>
        ) : (
          <Chip label={scriptChip.label} size='small' color={scriptChip.color} variant='outlined' sx={PIPELINE_CHIP_SX} />
        )}
        <Typography variant='caption' color='text.secondary' sx={{ flexShrink: 0 }}>→</Typography>
        <Typography variant='caption' color='text.secondary' sx={{ flexShrink: 0 }}>VO</Typography>
        {voStatus === 'completed' ? (
          <CheckIcon color='success' fontSize='small' titleAccess='Voice-over completed' sx={{ flexShrink: 0 }} />
        ) : (
          <Chip label={voChip.label} size='small' color={voChip.color} variant='outlined' sx={PIPELINE_CHIP_SX} />
        )}
        <Typography variant='caption' color='text.secondary' sx={{ flexShrink: 0 }}>→</Typography>
        <Typography variant='caption' color='text.secondary' sx={{ flexShrink: 0 }}>Video</Typography>
        {renderStatus === 'completed' ? (
          <CheckIcon color='success' fontSize='small' titleAccess='Video completed' sx={{ flexShrink: 0 }} />
        ) : (
          <Chip label={videoLabel} size='small' color={videoColor} variant='outlined' sx={PIPELINE_CHIP_SX} />
        )}
      </Box>
      {renderInProgress && renderProgressInfo?.progress != null && (
        <LinearProgress
          variant='determinate'
          value={renderProgressInfo.progress}
          sx={{ height: 4, borderRadius: 1 }}
        />
      )}
    </Box>
  );
}
